import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import { IEnvironnements } from "../../components/environnement/environnements";
import { MultiSelectEnv } from "../../components/environnement/MultiSelectEnv";
import { FieldElementSearch } from "../../components/list/FieldElementSearch";
import { StatusChip } from "./StatusChip";
import { DropdownItem } from "./Workflow";

interface FilterWorkFlows {
  filterNameOrId: string;
  setFilterNameOrID: (value: string) => void;
  setSelectedStatus: (value: DropdownItem) => void;
  statusFilterItems: DropdownItem[];
  selectedStatus: DropdownItem | undefined;
  setSelectedEnvs: (value: IEnvironnements[]) => void;
  envsSelected: IEnvironnements[];
}

export const FilterWorkFlows = ({
  filterNameOrId,
  selectedStatus,
  statusFilterItems,
  setFilterNameOrID,
  setSelectedStatus,
  setSelectedEnvs,
  envsSelected,
}: FilterWorkFlows) => {
  const { t } = useTranslation();

  return (
    <div className="grid">
      <div className="col-4">
        <FieldElementSearch
          value={filterNameOrId}
          changeValue={(val) => {
            setFilterNameOrID(val);
          }}
          placeholder={"Rechercher"}
        />
      </div>
      <div className="col-2">
        <Dropdown
          value={selectedStatus}
          options={statusFilterItems}
          onChange={(e) => {
            setSelectedStatus(e.value);
          }}
          optionLabel="name"
          placeholder={"Etat : tout"}
          itemTemplate={(item: DropdownItem) => (
            <StatusChip status={item.code} />
          )}
          valueTemplate={(item: DropdownItem, props: { placeholder: string }) =>
            item ? (
              <StatusChip status={item.code} />
            ) : (
              <span>{props.placeholder}</span>
            )
          }
          showClear
          className={"w-full"}
        />
      </div>
      <div className="col-2">
        <MultiSelectEnv
          envsSelected={envsSelected}
          setSelectedEnvs={(envs) => {
            setSelectedEnvs(envs);
          }}
        />
      </div>
    </div>
  );
};
